var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.data,"label":_vm.label,"loading":_vm.loading,"clearable":"","deletable-chips":"","item-value":"id","item-text":"name","color":"primary","placeholder":"Select level"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }